module.exports = "//static.hsappstatic.net/marketplace-ui-details/static-1.8498/img/Tier_Leading.svg"